import axiosInstance from "../axiosInstance";

export const fetchVendorStates = async () => {
    try {
        const response = await axiosInstance.get("/location/vendors/states");

        if(response.status === 200){
            return response.data;
        }
        else{
            return [];
        }
    } catch (error) {
        console.error("Error fetching states:", error);
        return [];
    }
};
